<template>
    <CompassPill :label="label" :variant="pillType" :size="size" :color="pillColor" />
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    label: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        required: true,
        validator(value) {
            return [
                'contact',
                'client',
                'prospect',
                'supplier',
                'company',
                'individual',
                'archived',
                'reference',
            ].includes(value);
        },
    },
    size: {
        type: String,
        default: 'medium',
        validator(value) {
            return ['extra-small', 'small', 'medium', 'large'].includes(value);
        },
    },
});

const pillType = computed(() => {
    return props.type === 'reference' ? 'stroked' : 'pastel';
});

const pillColor = computed(() => {
    switch (props.type) {
        case 'contact':
            return 'teal';
        case 'client':
            return 'light-blue';
        case 'prospect':
            return 'purple';
        case 'supplier':
            return 'coral';
        case 'company':
            return 'blue';
        case 'individual':
            return 'orange';
        case 'archived':
        case 'reference':
        default:
            return 'gray';
    }
});
</script>
